<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title :class="{ 'hidden-sm-and-down': showSearch }">
        Groups
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row v-if="showSearch" align="center" style="max-width: 300px;">
        <v-text-field
          flat
          hide-details
          single-line
          label="Search group"
          v-model="filter.search"
          @input="search"
        >
        </v-text-field>
      </v-row>
      <v-btn class="ml-5" icon @click="showSearch = !showSearch">
        <v-icon>{{ icons.search }}</v-icon>
      </v-btn>
    </v-app-bar>
    <div class="ma-4">
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">Name</th>
            <th class="text-left">Address</th>
            <th class="text-left">Created by</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="groups.data.length">
            <tr v-for="group in groups.data" :key="group.id">
              <td class="py-2">
                <text-highlight :queries="filter.search">
                  {{ group.name }}
                </text-highlight>
              </td>
              <td class="py-2">
                <text-highlight :queries="filter.search">
                  {{ group.address }}
                </text-highlight>
              </td>
              <td>{{ group.created_by.full_name }}</td>
              <td class="text-right">
                <router-link
                  :to="{ name: 'groups.edit', params: { id: group.id } }"
                >
                  <v-btn text icon>
                    <v-icon dark>{{ icons.edit }}</v-icon>
                  </v-btn>
                </router-link>
              </td>
            </tr>
          </template>
          <tr v-else>
            <td class="text-center headline grey--text py-10" colspan="6">
              No groups available.
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-overlay absolute :value="loading" opacity="0.1">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </div>
    <div v-if="paginationLength > 1" class="text-center mt-4">
      <v-pagination
        @input="pageChanged"
        :value="groups.meta.current_page"
        :length="paginationLength"
        :total-visible="groups.meta.per_page"
        circle
      >
      </v-pagination>
    </div>
  </div>
</template>

<script>
import Group from '@/models/Group'
import debounce from 'lodash/debounce'
import { mdiPencil, mdiMagnify } from '@mdi/js'
import TextHighlight from 'vue-text-highlight'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'GroupsPage',

  components: {
    TextHighlight,
    AppBarNavIcon
  },

  data() {
    return {
      loading: false,
      showSearch: false,
      filter: {
        search: ''
      },
      icons: {
        edit: mdiPencil,
        search: mdiMagnify
      },
      groups: {
        data: [],
        meta: {
          current_page: 1
        }
      }
    }
  },

  computed: {
    paginationLength() {
      return this.groups.meta.last_page
    }
  },

  methods: {
    getGroups() {
      this.loading = true
      return (
        Group.include('created_by')
          // .where('search', this.filter.search)
          .page(parseInt(this.groups.meta.current_page))
          .limit(10)
          .get()
          .then(response => {
            this.groups = response
          })
          .catch(() => {})
          .finally(() => (this.loading = false))
      )
    },

    pageChanged(page) {
      this.groups.meta.current_page = page
      this.getGroups()
    },

    search: debounce(function() {
      this.getGroups()
    }, 600),

    edit(group) {
      this.$router.push({ name: 'groups.edit', params: { id: group.id } })
    }
  },

  created() {
    this.getGroups()
  }
}
</script>
